export const USER_TABLE = Object.freeze({
  TABLE_NAME: 'user-table',
  USERNAME_FIELD: 'username',
});

export const TEAM_TABLE = Object.freeze({
  TABLE_NAME: 'team-table',
  NAME_FIELD: 'name',
  USER_COUNT_FIELD: 'user_count',
});

export const SELECT_ALL_ASSIGNMENT_TARGET = 'select-all-assignments';

export const MAIN_TAB_DEVICES = 'devices';
export const MAIN_TAB_GROUPS = 'lines-of-business';
export const MAIN_TAB_INVITATIONS = 'invitations';
export const MAIN_TAB_TEAMS = 'teams';
export const MAIN_TAB_USERS = 'users';

export const SETTINGS_TAB_GENERAL = 'general';
export const SETTINGS_TAB_SECURITY = 'security';
export const SETTINGS_TAB_SSO = 'sso';


export const RDC_GAUGE_EXPERIMENT = 'web-ui-jobs-rdc-gauge';
